import axios from '../helpers/api';
import db from '@/services/pouchDb';
import helper from '../helpers/custom/index';
const { v4: uuidv4 } = require('uuid');
import _ from 'lodash';
// import { DateTime } from 'luxon';
// import { version } from './../../package.json';
 


export const leadsOnBoardingService = {
    getProductConfigurator,
};

async function getProductConfigurator(page = 1, size = 1000, sortField = 'dateCreated', sortOrder = 'DESC', search='') {
    const res = await axios.get(
        `/api/onboarding/product/product-configurator?page=${page}&size=${size}&sortField=${sortField}&sortOrder=${sortOrder}&search=${search}`,
    );
    return res.data;
}